import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaCheckCircle,
  FaCaretDown,
  FaUser,
  FaUsers,
  FaClock,
  FaBirthdayCake,
  FaGlobe,
} from "react-icons/fa";
import "./travel-new.css";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useMemo } from "react";
import PlanSelection from "./Travel-Selection";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import Swal from "sweetalert2";
import { useLoading } from "../contexts/LoadingContext";
import SubscriptionCard from "./travel-subscripiton";
import { useLocation } from "react-router-dom";
import { checkInsurance } from "../services/api";
import SoloTravelerModal from "../components/solo-travel-model";
import FamilyTravelerModal from "../components/family-travel-modal";
export const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      // If clicking inside the element → do nothing
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      // Clicked outside → call handler
      handler();
    };

    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px",
    border: "1px solid #eeaf03",
    fontSize: "13px",
    boxShadow: state.isFocused ? "0 0 0 1px #eeaf03" : "none",
    "&:hover": {
      border: "1px solid #eeaf03",
    },
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: "13px",
    backgroundColor: state.isFocused
      ? "#fff3cd"
      : state.isSelected
        ? "#eeaf03"
        : "white",
    color: "#212529",
    cursor: "pointer",
  }),

  singleValue: (provided) => ({
    ...provided,
    color: "#212529",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#eeaf03",
    "&:hover": {
      color: "#eeaf03",
    },
  }),

  indicatorSeparator: () => ({
    display: "none", // optional: removes line
  }),
};
const TRAVEL_API_BASE =
  "https://miniappeasypaisa.webddocsystems.com/public/api/v1";

export default function TravelApp() {
  const [step, setStep] = useState(1);
  const [gender, setGender] = useState("Female");
  const [travelType, setTravelType] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [zone, setZone] = useState();
  const [destination, setDestination] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [coverageType, setCoverageType] = useState("full");
  const startRef = useRef(null);
  const endRef = useRef(null);
  const calendarRef = useRef(null);
  const [age, setAge] = useState(null);
  const [dob, setDob] = useState(null);
  const [dobError, setDobError] = useState("");
  const today = new Date();
  const [duration, setDuration] = useState(null);
  const { setIsLoading } = useLoading();
  const [customerNumber, setCustomerNumber] = useState(null);
  const [activeSub, setActiveSub] = useState(null); // null=loading, false=none, obj=found
  const [subChecked, setSubChecked] = useState(false);
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  const [showSoloPopup, setShowSoloPopup] = useState(false);
  const [showFamilyPopup, setShowFamilyPopup] = useState(false);
  const [soloData, setSoloData] = useState({
    passport: "",
    passport_expiry: "",
    beneficiaryName: "",
    cnic: "",
    relation: "",
  });
  const [family, setFamily] = useState({
    self: {
      name: "",
      cnic: "",
      passport: "",
    },
    wife: {
      name: "",
      cnic: "",
      passport: "",
    },
    kids: [{ name: "", passport: "" }],
  });
  const params = new URLSearchParams(location.search);
  const openId = params.get("openId");
  const isBack = params.get("isBack") === "true";
  useClickOutside(startRef, () => setShowStartCalendar(false));
  useClickOutside(endRef, () => setShowEndCalendar(false));
  useClickOutside(calendarRef, () => setShowCalendar(false));
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  );

  const minDate = new Date(
    today.getFullYear() - 90,
    today.getMonth(),
    today.getDate(),
  );
  const [selectedDate, setSelectedDate] = useState(maxDate);

  const month = today.getMonth();
  const year = today.getFullYear();

  const options = useMemo(() => {
    return countryList()
      .getData()
      .map((c) => ({
        ...c,
        flagUrl: `https://flagcdn.com/24x18/${c.value.toLowerCase()}.png`, // 24x18 size
      }));
  }, []);
  const checkInsuranceStatus = async (openId) => {
    try {
      const response = await checkInsurance(openId, "Travel");

      return response; // Return the response so we can check it in useEffect
    } catch (err) {
      console.error("Insurance check error:", err);

      return null;
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${d} - ${m} - ${y}`;
  };

  const handleDobChange = (date) => {
    const today = new Date();

    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();
    const d = today.getDate() - date.getDate();

    if (m < 0 || (m === 0 && d < 0)) {
      age--;
    }

    if (age < 18 || age > 90) {
      setDobError("Age must be between 18 and 90 years.");
      return;
    }

    setSelectedDate(date);
    setDob(date);
    setAge(age);
    setDobError("");
    setShowCalendar(false);
  };
  const handleSelect = (value, type) => {
    let fullDate;

    // ✅ If value is already a Date (react-calendar)
    if (value instanceof Date) {
      fullDate = value;
    } else {
      // old logic (fallback)
      if (!value) return;
      fullDate = new Date(year, month, value);
    }

    const formatted = fullDate
      .toLocaleDateString("en-GB")
      .replace(/\//g, " - ");

    if (type === "start") {
      const selected = new Date(fullDate);
      selected.setHours(0, 0, 0, 0);

      // ❌ Block past dates
      if (selected < today) {
        // optional error state
        setStartDate("");
        return;
      }

      setStartDate(formatted);
      setShowStartCalendar(false);

      // reset end date if it's before new start date
      if (endDate) {
        const endParts = endDate.split(" - ");
        const end = new Date(endParts[2], endParts[1] - 1, endParts[0]);

        if (end < selected) {
          setEndDate("");
          setDuration(0);
          return;
        }

        const diffDays = Math.ceil((end - selected) / (1000 * 60 * 60 * 24));
        setDuration(diffDays > 0 ? diffDays : 0);
      }
    } else if (type === "end") {
      setEndDate(formatted);
      setShowEndCalendar(false);

      if (startDate) {
        const startParts = startDate.split(" - ");
        const start = new Date(startParts[2], startParts[1] - 1, startParts[0]);

        const diffDays = Math.ceil((fullDate - start) / (1000 * 60 * 60 * 24));
        setDuration(diffDays > 0 ? diffDays : 0);
      }
    }
  };
  const fetchSubscriptionStatus = async (custNum) => {
    setIsLoading(true);
    try {
      const res = await fetch(
        `${TRAVEL_API_BASE}/travel-insurance/subscription?customerNumber=${custNum}&service=TravelInsurance`,
        // { headers: { Authorization: AUTH_HEADER } }
      );
      const data = await res.json();
      setActiveSub(
        data?.responseCode === "0000" && data?.data ? data.data : false,
      );
    } catch (err) {
      console.error("Subscription check error:", err);
      setActiveSub(false);
    } finally {
      setSubChecked(true);
      setIsLoading(false);
    }
  };
  const getUserAuthCodeResult = (jsonResult) => {
    const result = JSON.parse(jsonResult);
    try {
      if (result.status === "SUCCESS") {
        const form = new FormData();
        form.append("value", result.authCode);
        form.append("apikey", "Travel");

        axios
          .post(`${TRAVEL_API_BASE}/insurance-auth`, form, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.openId) {
              sessionStorage.setItem("user", JSON.stringify(response.data));
              setUserData(response.data);
              setCustomerNumber(response.data.userMsisdn);
            } else {
              Swal.fire({
                icon: "info",
                allowOutsideClick: false,
                title: "Something went wrong. Please try again later!",
                confirmButtonText: "Retry",
              }).then(() => authenticateUser());
            }
          })
          .catch((error) => {
            console.error(error);
            setIsLoading(false);
          });
      } else {
        Swal.fire({
          allowOutsideClick: false,
          title: "Please Share the information for Services",
          confirmButtonText: "Retry",
        }).then((r) => {
          if (r.isConfirmed) authenticateUser();
          else setIsLoading(false);
        });
      }
    } catch (error) {
      console.error("Error processing auth code:", error);
      setIsLoading(false);
    }
  };

  const authenticateUser = () => {
    //setIsLoading(true);
    const scopes = [
      "USER_MSISDN",
      "USER_NAME",
      "OPEN_ID",
      "UNION_ID",
      "USER_BIRTHDAY",
    ];
    window.mp.getUserAuthCode(scopes);
    window.getUserAuthCodeResult = getUserAuthCodeResult;
  };
  useEffect(() => {
    const verifyInsuranceAuth = async () => {
      setIsLoading(true);
      try {
        if (isBack) {
          console.log("Skipping authentication due to isBack being true");
          const user = {
            openId: "5da34d83de18ba92f44040c10b406c8ad4bb1375",
            unionId: "5ba759f37b91d2a51f20c014a7c3ba2a504055c7",
            userMsisdn: "03145362496",
            userName: "Khumash hussain",
            // applicationUserId: "27C62D9C-AB40-450C-A6CE-7851F47190FA",
            // applicationUserId: "09ec867f-04ab-4ac2-ac76-896c68cfecab",
            applicationUserId: "0d8968b7-65a9-4db6-84c3-8c8b3e67f946",
            // applicationUserId: "2F02828E-B0E0-4570-9815-CDFBFB7D6DD0",
            // userEmail: "03145362496@webdoc.com.pk",
            // userEmail: "03145362496@kashtkaar.com.pk",
            userEmail: "03145362496@vetdoctor.com.pk",
            // applicationUserId: "B11000A1-70CA-4E67-A2A1-11DF65FEE0D9",
            package: "",
            message: "User registered and authenticated successfully  .",
          };

          sessionStorage.setItem("user", JSON.stringify(user));
          console.log(sessionStorage.getItem("user"));

          const userData = JSON.parse(sessionStorage.getItem("user"));
          const session = JSON.parse(sessionStorage.getItem("user"));

          setCustomerNumber(session.userMsisdn);
          setUserData(session);

          return;
        }
        if (!openId) {
          console.log("No openId found, proceeding with authentication");
          authenticateUser();
          return;
        }

        const response = await checkInsuranceStatus(openId);
        console.log("Insurance Status:", response);

        // Check if we have a valid response with openId
        if (response && response.openId) {
          console.log("Valid user data found, setting session");
          sessionStorage.setItem("user", JSON.stringify(response));
          setIsLoading(false);
          setCustomerNumber(response.userMsisdn);
          setUserData(response);
        } else {
          console.log(
            "No valid user data found, proceeding with authentication",
          );
          authenticateUser();
        }
      } catch (error) {
        console.error("Error during insurance verification:", error);
        authenticateUser();
      }
    };

    verifyInsuranceAuth();
  }, [location.search, isBack, openId]);
  const handleUnsubscribe = async () => {
    const confirm = await Swal.fire({
      icon: "warning",
      title: "Unsubscribe?",
      text: "Are you sure you want to cancel your Travel Insurance subscription?",
      showCancelButton: true,
      confirmButtonText: "Yes, Unsubscribe",
      cancelButtonText: "No, Keep it",
      confirmButtonColor: "#d33",
    });
    if (!confirm.isConfirmed) return;

    setIsLoading(true);
    try {
      const res = await fetch(
        `${TRAVEL_API_BASE}/travel-insurance/unsubscribe`,
        {
          method: "POST",
          body: JSON.stringify({
            customerNumber: customerNumber,
            subscriptionID: activeSub.subscriptionID,
          }),
        },
      );
      const data = await res.json();
      if (data?.responseCode === "0000") {
        Swal.fire({
          icon: "success",
          title: "Unsubscribed",
          text: "Your subscription has been cancelled.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data?.message || "Could not unsubscribe. Please try again.",
        });
      }
    } catch (err) {
      console.error("Unsubscribe error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (userData && customerNumber) {
      fetchSubscriptionStatus(customerNumber);
    }
  }, [userData, customerNumber, step]);
  const validateCNIC = (cnic) => {
    const regex = /^\d{5}-\d{7}-\d{1}$/;
    return regex.test(cnic);
  };
  const validatePassport = (passport) => {
    const regex = /^[A-Z0-9]{5,9}$/i;
    return regex.test(passport);
  };
  const formatPassport = (v) =>
    v
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 9);

  const formatCNIC = (value) => {
    let v = value.replace(/\D/g, "");

    if (v.length > 5) v = v.slice(0, 5) + "-" + v.slice(5);
    if (v.length > 13) v = v.slice(0, 13) + "-" + v.slice(13, 14);

    return v;
  };
  const handleSoloChange = (field, value) => {
    setSoloData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleWifeChange = (field, value) => {
    setFamily((prev) => ({
      ...prev,
      wife: { ...prev.wife, [field]: value },
    }));
  };
  const handleKidChange = (index, field, value) => {
    const updatedKids = [...family.kids];
    updatedKids[index][field] = value;

    setFamily((prev) => ({
      ...prev,
      kids: updatedKids,
    }));
  };
  const addKid = () => {
    if (family.kids.length >= 3) return;

    setFamily((prev) => ({
      ...prev,
      kids: [...prev.kids, { name: "", passport: "" }],
    }));
  };
  const removeKid = (index) => {
    const updatedKids = family.kids.filter((_, i) => i !== index);

    setFamily((prev) => ({
      ...prev,
      kids: updatedKids,
    }));
  };
  console.log("Solo Data:", soloData);
  console.log("family Data:", family);
  if (userData && activeSub) {
    return (
      <SubscriptionCard
        subscriptionData={activeSub}
        onUnsubscribe={handleUnsubscribe}
      />
    );
  } else
    return (
      <div className="max-w-4xl mx-auto p-4">
        {/* Step */}
        <div className="text-center mb-4">
          <h5 className="font-bold text-lg">Step {step} of 2</h5>
        </div>

        {step === 1 && (
          <>
            <h2 className="text-center font-bold text-2xl">
              Secure Your Journey
            </h2>
            <p className="text-center text-gray-500">
              Fill out the details below to get started.
            </p>

            {/* MAIN CARD */}
            <div className="flex flex-col rounded-2xl shadow-sm min-h-50 min-w-50 outline outline-gray-300">
              <h6 className="my-4 px-4 font-semibold">Who are you?</h6>

              <div className="flex px-2">
                {/* LEFT */}

                <div className="flex gap-2 w-1/2">
                  {/* Female */}
                  <div
                    className={`relative cursor-pointer rounded-xl text-center ${
                      gender !== "Female" && "grayscale"
                    }`}
                    onClick={() => setGender("Female")}
                  >
                    <img src="/women.PNG" alt="female" />
                    {gender === "Female" && (
                      <FaCheckCircle className="absolute top-1 md:top-3 md:right-3 right-1 h-5 w-5 md:h-8 md:w-8 text-amber-500 " />
                    )}
                    <p className="text-sm font-medium mt-1">Female</p>
                  </div>

                  {/* Male */}
                  <div
                    className={`relative cursor-pointer rounded-xl text-center ${
                      gender !== "Male" && "grayscale"
                    }`}
                    onClick={() => setGender("Male")}
                  >
                    <img src="/male.png" alt="male" />
                    {gender === "Male" && (
                      <FaCheckCircle className="absolute top-1 md:top-3 md:right-3 right-1 h-5 w-5 md:h-8 md:w-8 text-amber-500 " />
                    )}
                    <p className="text-sm font-medium mt-1">Male</p>
                  </div>
                </div>
                {/* RIGHT */}
                <div className=" flex-1 flex ">
                  <div className="w-full h-full rounded-xl overflow-hidden">
                    <img
                      src="/travel.png"
                      alt="travel"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
              <div className="px-4">
                {/* DOB */}

                <label className="text-sm font-medium mt-3 block">
                  Date of Birth
                </label>

                <div className="relative mb-3">
                  <div
                    className="flex items-center justify-between outline outline-amber-400 rounded-lg px-3 py-2 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowCalendar(!showCalendar);
                    }}
                  >
                    <input
                      type="text"
                      className="w-full outline-none text-sm font-medium"
                      placeholder="DD - MM - YYYY"
                      value={formatDate(dob)}
                      readOnly
                    />
                    <FaCaretDown className="text-amber-500" />
                  </div>

                  {showCalendar && (
                    <div className=" calendar-popup">
                      <Calendar
                        onChange={handleDobChange}
                        value={selectedDate}
                        minDate={minDate}
                        maxDate={maxDate}
                      />
                    </div>
                  )}

                  {dobError && (
                    <div className="text-xs text-red-500 mt-1">{dobError}</div>
                  )}
                </div>
              </div>
            </div>

            {/* DESTINATION */}
            <div className="shadow-sm mt-3 p-4 border rounded-2xl">
              <h6 className="mb-3 font-semibold">Where are you going?</h6>

              <Select
                options={options}
                value={options.find((c) => c.value === zone)}
                onChange={(selected) => {
                  setZone(selected.value);
                  setDestination(selected.label);
                }}
                placeholder="Select destination country"
                styles={customStyles}
              />
            </div>

            {/* TRAVEL TYPE */}
            <div className="my-3 shadow-sm  pt-4 border rounded-2xl">
              <h6 className="font-semibold px-4">
                Who are you traveling with?
              </h6>

              <div className="flex gap-2 px-2 mt-3">
                {["Solo", "Family", "Student"].map((type) => (
                  <div
                    key={type}
                    onClick={() => {
                      setTravelType(type);
                      setShowSoloPopup(type === "Solo" || type === "Student");
                      setShowFamilyPopup(type === "Family");
                    }}
                    className={`relative cursor-pointer rounded-xl  text-center ${
                      travelType !== type && "grayscale"
                    }`}
                  >
                    <img src={`${type.toLowerCase()}.png`} alt={type} />
                    {travelType === type && (
                      <FaCheckCircle className="absolute top-2 md:top-3 md:right-3 right-2 h-6 w-6 md:h-8 md:w-8 text-amber-500 " />
                    )}
                    <p className="mt-2">{type}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* DATES */}
            <div className="my-3 shadow-sm  pt-4 border rounded-2xl">
              <h6 className="font-semibold px-4">
                How long will you be traveling?
              </h6>

              <div className="flex pb-4 gap-2 mt-2 px-2">
                {/* Start */}
                <div className="relative w-full">
                  <div
                    className="flex justify-between items-center outline outline-amber-400 rounded-lg px-3 py-2 cursor-pointer input-wrapper"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowStartCalendar(!showStartCalendar);
                    }}
                  >
                    <input
                      type="text"
                      className="w-full outline-none text-sm"
                      placeholder="Start Date"
                      value={startDate}
                      readOnly
                    />
                    <FaCaretDown className="text-amber-500" />
                  </div>
                  {showStartCalendar && (
                    <div className="calendar-popup" ref={startRef}>
                      <Calendar
                        onChange={(date) => handleSelect(date, "start")}
                        value={
                          startDate
                            ? new Date(
                                startDate.split(" - ")[2],
                                startDate.split(" - ")[1] - 1,
                                startDate.split(" - ")[0],
                              )
                            : null
                        }
                        minDate={new Date()} // today onwards
                      />
                    </div>
                  )}
                </div>

                {/* End */}
                <div className="relative w-full">
                  <div
                    className="flex justify-between items-center outline outline-amber-400 rounded-lg px-3 py-2 cursor-pointer input-wrapper"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowEndCalendar(!showEndCalendar);
                    }}
                  >
                    <input
                      type="text"
                      className="w-full outline-none text-sm"
                      placeholder="End Date"
                      value={endDate}
                      readOnly
                    />
                    <FaCaretDown className="text-amber-500" />
                  </div>

                  {showEndCalendar && (
                    <div className="calendar-popup end-popup" ref={endRef}>
                      <Calendar
                        onChange={(date) => handleSelect(date, "end")}
                        value={
                          endDate
                            ? new Date(
                                endDate.split(" - ")[2],
                                endDate.split(" - ")[1] - 1,
                                endDate.split(" - ")[0],
                              )
                            : null
                        }
                        minDate={
                          startDate
                            ? new Date(
                                startDate.split(" - ")[2],
                                startDate.split(" - ")[1] - 1,
                                startDate.split(" - ")[0],
                              )
                            : new Date()
                        }
                        maxDate={(() => {
                          const base = startDate
                            ? new Date(
                                startDate.split(" - ")[2],
                                startDate.split(" - ")[1] - 1,
                                startDate.split(" - ")[0],
                              )
                            : new Date();

                          const max = new Date(base);
                          max.setFullYear(max.getFullYear() + 2);
                          return max;
                        })()}
                      />
                    </div>
                  )}
                </div>
              </div>
              {duration > 92 && (
                <div className=" py-4 px-2">
                  <h6 className="px-3">Select Coverage Type</h6>

                  <div className="relative flex items-center justify-between bg-gray-100 rounded-xl w-full  overflow-hidden">
                    {/* Sliding background */}
                    <div
                      className={`absolute top-1 bottom-1 w-1/2 bg-yellow-500 rounded-xl transition-all duration-300 ease-in-out ${
                        coverageType === "limited" ? "left-1" : "left-1/2"
                      }`}
                    />

                    {/* Limited */}
                    <button
                      type="button"
                      onClick={() => setCoverageType("limited")}
                      className={`relative z-10 w-1/2 py-3 px-2 rounded-xl font-medium text-sm transition-colors duration-300 ${
                        coverageType === "limited"
                          ? "text-gray-800"
                          : "text-gray-500"
                      }`}
                    >
                      Limited (92 days)
                    </button>

                    {/* Full */}
                    <button
                      type="button"
                      onClick={() => setCoverageType("full")}
                      className={`relative z-10 w-1/2 py-3 px-2 rounded-xl font-medium text-sm transition-colors duration-300 ${
                        coverageType === "full"
                          ? "text-gray-800"
                          : "text-gray-500"
                      }`}
                    >
                      Full (180 days)
                    </button>
                  </div>
                </div>
              )}
            </div>
            <SoloTravelerModal
              isOpen={showSoloPopup}
              type={travelType}
              onClose={() => {
                setShowSoloPopup(false);
                setTravelType("");
              }}
              soloData={soloData}
              handleSoloChange={handleSoloChange}
              formatPassport={formatPassport}
              formatCNIC={formatCNIC}
              validateCNIC={validateCNIC}
              onSave={(data) => {
                console.log("MODAL DATA:", data);
                setShowSoloPopup(false);
                // const wife = data.extras.find((m) => m.role === "spouse");
                // const kids = data.extras.filter((m) => m.role === "child");

                // setFamily({
                //   wife: {
                //     name: wife?.name || "",
                //     cnic: "", // you can extend later
                //     passport: wife?.passport || "",
                //   },
                //   kids: kids.map((k) => ({
                //     name: k.name,
                //     passport: k.passport,
                //   })),
                // });
              }}
            />

            <FamilyTravelerModal
              isOpen={showFamilyPopup}
              onClose={() => {
                setShowFamilyPopup(false);
                setTravelType("");
              }}
              family={family}
              handleWifeChange={handleWifeChange}
              handleKidChange={handleKidChange}
              soloData={soloData}
              handleSoloChange={handleSoloChange}
              addKid={addKid}
              removeKid={removeKid}
              validateCNIC={validateCNIC}
              formatCNIC={formatCNIC}
              formatPassport={formatPassport}
              onSave={(data) => {
                console.log("family model ---", data);
                const wife = data.extras.find((m) => m.role === "spouse");
                const kids = data.extras.filter((m) => m.role === "child");

                setFamily({
                  self: data.self, // ✅ added
                  wife: {
                    name: wife?.name || "",
                    cnic: wife?.cnic,
                    passport: wife?.passport || "",
                  },
                  kids: kids.map((k) => ({
                    name: k.name,
                    passport: k.passport,
                  })),
                });
                setShowFamilyPopup(false);
              }}
            />
            {/* SUMMARY */}
            <div className="my-3 shadow-sm p-4 border rounded-2xl">
              <p className="font-bold mb-3">Summary:</p>

              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-3">
                  {" "}
                  <FaUser className="summary-icon text-danger" /> {gender}
                </div>

                <div className="flex items-center gap-3">
                  {" "}
                  {zone ? (
                    <img
                      src={options.find((c) => c.value === zone)?.flagUrl}
                      alt={zone}
                      style={{
                        width: "18px",
                        height: "18px",
                        objectFit: "contain",
                        borderRadius: "2px",
                      }}
                    />
                  ) : (
                    <>
                      <FaGlobe className="summary-icon text-grey" />
                    </>
                  )}
                  {zone || "-"}
                </div>
                <div className="flex items-center gap-3">
                  {" "}
                  <FaUsers className="summary-icon text-info" /> {travelType}
                </div>
                <div className="flex items-center gap-3">
                  {" "}
                  <FaBirthdayCake className="summary-icon text-primary" />{" "}
                  {age ? (
                    `${age} years`
                  ) : (
                    <span className="text-danger">Age not set</span>
                  )}
                </div>
                <div className="flex items-center gap-3">
                  {" "}
                  <FaClock className="summary-icon text-success" />{" "}
                  {duration ? `${duration} days` : "-"}
                </div>
              </div>
            </div>
            <div className="justify-center items-center flex">
              {/* BUTTON */}
              <button
                onClick={() => setStep(2)}
                disabled={!age || !duration || !zone}
                className="w-60 mt-3 py-3 text-black font-semibold rounded-2xl! bg-amber-400 disabled:opacity-50"
              >
                Continue
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <PlanSelection
            destination={destination}
            coverageType={coverageType}
            setStep={setStep}
            age={age}
            duration={duration}
            zone={zone}
            travelType={travelType}
            startDate={startDate}
            endDate={endDate}
            soloData={soloData}
            family={family}
          />
          // <PlanSelection
          //   destination={destination}
          //   coverageType={coverageType}
          //   setStep={setStep}
          //   age={age}
          //   duration={duration}
          //   zone={zone}
          //   travelType={travelType}
          // />
        )}
      </div>
    );
}
